import React, { useState, useEffect, SyntheticEvent, forwardRef } from 'react'
import { Snackbar, IconButton } from '@mui/material'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import { CloseIcon } from './Icons'
import { GenericSnackbarProps, SnackbarProps } from './Snackbars.types'

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

function GenericSnackbar({
    message,
    variant,
    onClose,
    horizontal,
    vertical,
}: GenericSnackbarProps) {
    const [open, setOpen] = useState(false)

    const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
        if (typeof onClose === 'function') {
            onClose()
        }
        setOpen(false)
    }

    useEffect(() => {
        setOpen(!!message)
    }, [message])

    return (
        <Snackbar
            open={open}
            anchorOrigin={{
                vertical: vertical ?? 'bottom',
                horizontal: horizontal ?? 'right',
            }}
            action={
                <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
            onClose={handleClose}
        >
            <Alert
                onClose={handleClose}
                severity={variant}
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}

export function ErrorSnackbar(props: SnackbarProps) {
    return (
        <GenericSnackbar
            variant="error"
            message={props.message}
            onClose={props.onClose}
            horizontal={props.horizontal}
        />
    )
}

export function SuccessSnackbar(props: SnackbarProps) {
    return (
        <GenericSnackbar
            variant="success"
            message={props.message}
            onClose={props.onClose}
            horizontal={props.horizontal}
        />
    )
}

export function WarningSnackbar(props: SnackbarProps) {
    return (
        <GenericSnackbar
            variant="warning"
            message={props.message}
            onClose={props.onClose}
            horizontal={props.horizontal}
        />
    )
}

export function InfoSnackbar(props: SnackbarProps) {
    return (
        <GenericSnackbar
            variant="info"
            message={props.message}
            onClose={props.onClose}
            horizontal={props.horizontal}
        />
    )
}
